class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.classList.remove('is-empty');
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

document.addEventListener('click', async (event) => {
  const btn = event.target.closest('[data-cart-upgrade-sub]');
  if (!btn || btn.disabled) return;
  event.preventDefault();
  const isBogo =
    btn.hasAttribute('data-bogo-upgrade') ||
    Boolean(window.FU_BOGO_MODE || /[?&]view=bogo\b/i.test(window.location.search)) ||
    (function () {
      try {
        return sessionStorage.getItem('fu_bogo_mode') === '1';
      } catch (e) {
        return false;
      }
    })();
  btn.disabled = true;
  btn.textContent = 'Switching...';
  const qty = Math.max(1, parseInt(btn.dataset.qty, 10) || 1);
  const rootUrl = window.Shopify?.routes?.root || '/';
  const guideId = Number(window.FU_FREE_GUIDE_VARIANT_ID || 67813440225582);
  const freeBottleId = Number(window.FU_FREE_BOTTLE_VARIANT_ID || 67826240258350);
  const drawer = document.querySelector('cart-drawer');
  try {
    await fetch(`${rootUrl}cart/clear.js`, { method: 'POST', headers: { Accept: 'application/json' } });
    const items = [];
    if (guideId) {
      items.push({ id: guideId, quantity: 1, properties: { _free_gift: 'true' } });
    }
    if (isBogo && freeBottleId) {
      items.push({ id: freeBottleId, quantity: 1, properties: { _free_gift: 'true', _bogo_bonus: 'true' } });
    }
    items.push({ id: 51041057079598, quantity: qty, selling_plan: 693686272302 });
    const res = await fetch(`${rootUrl}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items,
        attributes: {
          lp_variant: window.fuLpVariant || (isBogo ? 'default' : 'control'),
          offer_mode: isBogo ? 'bogo' : 'control',
        },
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      }),
    });
    const parsed = await res.json();
    if (drawer && parsed.sections) {
      drawer.renderContents(parsed);
    } else {
      window.location.reload();
    }
  } catch (err) {
    console.error(err);
    btn.disabled = false;
    btn.textContent = isBogo
      ? 'Switch to BOGO Subscription ($19.99/mo)'
      : 'Switch to Monthly Subscription ($19.99/mo)';
  }
});
